import { useGenericRequestHandler } from '../../../handlers'

/**
 * @typedef {Object} MoteStatus
 * @property {boolean} isLoopy
 * @property {string} createdByAvatar
 * @property {string} createdByName
 * @property {string} studentName
 * @property {boolean} wasCreatedBySameUser
 * @property {number} lastSeenEpoch
 * @property {ToteEngagementMode | null} lastLoopMode
 * @property {string | null} lastTeply
 */

/**
 * @typedef {Object} MoteStatusQueryData
 * @property {MoteStatus} moteStatus
 * @property {Device} device
 */

/**
 * @param moteId
 * @param refetchInterval
 * @return {{[p: string]: *, data: MoteStatusQueryData | null}}
 */
export const useMoteStatusQuery = ({ moteId, refetchInterval }) => {
  return useGenericRequestHandler({
    route: `v1/m/status/${moteId}`,
    enabled: Boolean(moteId),
    refetchInterval,
    method: 'POST',
    options: { timeout: 25000 }
  })
}
